'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import React, { useRef, useState } from 'react';
import { ID_MENU, MENU_ITEMS } from '@/ui/segments/landing/constants';
import { IconChevronRight } from '@/ui/segments/landing/icons/icon-chevron-right';
import { IconMenu } from '@/ui/segments/landing/icons/icon-menu';
import { classNames } from '@/util/utils';
import PopupMenu from './popup-menu/popup-menu';
import type { MenuItem } from '@/ui/segments/landing/constants';
import type { EnumSection } from '@/ui/segments/landing/sections/sections';
import styles from './menu.module.css';
interface MenuProps {
  className?: string;
  scrollHasStarted?: boolean;
  section?: EnumSection;
}
export default function Menu(t0) {
  const $ = _c(33);
  const {
    className,
    scrollHasStarted: scrollHasStartedProp,
    section
  } = t0;
  const [showMenu, setShowMenu] = React.useState(false);
  const [showMenuComponent, setShowMenuComponent] = React.useState(true);
  const lastScrollYRef = useRef(0);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [internalScrollStarted, setInternalScrollStarted] = React.useState(false);
  const scrollHasStarted = scrollHasStartedProp ?? internalScrollStarted;
  const getParentItemForSection = _temp;
  let t1;
  if ($[0] !== section) {
    t1 = getParentItemForSection(section);
    $[0] = section;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const parentItem = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const lastScrollY = lastScrollYRef.current;
        setInternalScrollStarted(prev => {
          const next = currentScrollY > 0;
          return prev === next ? prev : next;
        });
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
          setShowMenuComponent(_temp2);
        } else {
          if (currentScrollY < lastScrollY) {
            setShowMenuComponent(_temp3);
          }
        }
        lastScrollYRef.current = currentScrollY;
      };
      lastScrollYRef.current = window.scrollY;
      setInternalScrollStarted(window.scrollY > 0);
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  React.useEffect(t2, t3);
  const t4 = scrollHasStarted && styles.stuck;
  const t5 = !showMenuComponent && styles.hidden;
  let t6;
  if ($[4] !== className || $[5] !== t4 || $[6] !== t5) {
    t6 = classNames(className, styles.menuContainer, t4, t5);
    $[4] = className;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = showMenuComponent ? "translateY(0)" : "translateY(-100%)";
  let t8;
  if ($[8] !== t7) {
    t8 = {
      transform: t7,
      transition: "transform 0.3s ease-in-out"
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="/" className={styles.logo}><h2>Open Brain Institute</h2></Link>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== hoveredItem || $[12] !== parentItem?.slug || $[13] !== section) {
    t10 = MENU_ITEMS.map(item_0 => <div key={item_0.slug} className={styles.menuItemContainer}>{item_0.submenu ? <div role="menuitem" data-testid={`header-desktop-menu-${item_0.slug.slice(1)}`} aria-haspopup="menu" tabIndex={0} className={styles.menuItemWithSubmenu} onMouseEnter={() => setHoveredItem(item_0.slug)} onMouseLeave={() => setHoveredItem(null)}><button type="button" data-testid={`header-desktop-menu-${item_0.slug.slice(1)}-toggle`} className={classNames(styles.menuButton, (item_0.index === section || parentItem?.slug === item_0.slug) && styles.selected)}><span className={styles.menuButtonContent}>{item_0.caption}<span className={styles.chevron}><IconChevronRight /></span></span></button><div className={classNames(styles.submenu, hoveredItem === item_0.slug && styles.submenuVisible, "bg-primary-8")}>{item_0.submenu.map(_temp4)}</div></div> : <Link href={item_0.slug} className={classNames(styles.menuLink, item_0.index === section && styles.selected)} data-testid={`header-desktop-link-${item_0.slug.slice(1)}`}>{item_0.caption}</Link>}</div>);
    $[11] = hoveredItem;
    $[12] = parentItem?.slug;
    $[13] = section;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/app/virtual-lab" className={classNames(styles.menuLink)} data-testid="header-desktop-link-app-virtual-lab">Login</Link>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <div className={styles.items}>{t10}{t11}</div>;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== showMenu) {
    t13 = () => setShowMenu(!showMenu);
    $[18] = showMenu;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <IconMenu />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <div className={styles.hamburger}><button type="button" onClick={t13} aria-label="Popup menu">{t14}</button></div>;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t12 || $[24] !== t15 || $[25] !== t6 || $[26] !== t8) {
    t16 = <div id={ID_MENU} data-testid="site-header" className={t6} style={t8}>{t9}{t12}{t15}</div>;
    $[23] = t12;
    $[24] = t15;
    $[25] = t6;
    $[26] = t8;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== showMenu) {
    t17 = <PopupMenu visible={showMenu} onChange={setShowMenu} />;
    $[28] = showMenu;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
}
function _temp4(subItem_0) {
  return <Link key={subItem_0.slug} href={subItem_0.slug} className={styles.submenuItem} data-testid={`header-desktop-link-${subItem_0.slug.slice(1)}`}>{subItem_0.caption}</Link>;
}
function _temp3(prev_1) {
  return prev_1 ? prev_1 : true;
}
function _temp2(prev_0) {
  return prev_0 ? false : prev_0;
}
function _temp(currentSection) {
  if (!currentSection) {
    return null;
  }
  return MENU_ITEMS.find(item => {
    if (item.submenu) {
      return item.submenu.some(subItem => subItem.index === currentSection);
    }
    return false;
  }) || null;
}